import { cn } from '@/lib/utils';

export type PickerSize = 'small' | 'medium' | 'large';

export const pickerOptionSizeClasses = {
  small: cn('py-0.5 text-sm'),
  medium: cn('py-1.5 text-sm'),
  large: cn('py-2 text-base'),
};

export const pickerTriggerIconSizeClasses = {
  small: cn('[&_svg]:size-4.5'),
  medium: cn('[&_svg]:size-5'),
  large: cn('[&_svg]:size-6'),
};
